/** Curated pick-lists for provider profile capture (aligned with backend matching) */

export const SA_PROVINCE_OPTIONS = [
  { value: "GP", label: "Gauteng (GP)" },
  { value: "WC", label: "Western Cape (WC)" },
  { value: "EC", label: "Eastern Cape (EC)" },
  { value: "KZN", label: "KwaZulu-Natal (KZN)" },
  { value: "LP", label: "Limpopo (LP)" },
  { value: "MP", label: "Mpumalanga (MP)" },
  { value: "NW", label: "North West (NW)" },
  { value: "NC", label: "Northern Cape (NC)" },
  { value: "FS", label: "Free State (FS)" },
];

const PROVINCE_ALIASES = {
  gauteng: "GP",
  gp: "GP",
  "western cape": "WC",
  wc: "WC",
  "eastern cape": "EC",
  ec: "EC",
  "kwazulu-natal": "KZN",
  "kwazulu natal": "KZN",
  kzn: "KZN",
  limpopo: "LP",
  lp: "LP",
  mpumalanga: "MP",
  mp: "MP",
  "north west": "NW",
  northwest: "NW",
  nw: "NW",
  "northern cape": "NC",
  nc: "NC",
  "free state": "FS",
  freestate: "FS",
  fs: "FS",
};

export const PROVIDER_SERVICE_OPTIONS = [
  { value: "share_load", label: "Share load" },
  { value: "exclusive_move", label: "Exclusive move" },
  { value: "packing", label: "Packing" },
  { value: "wrapping", label: "Wrapping" },
  { value: "storage", label: "Storage" },
  { value: "assembly", label: "Assembly" },
  { value: "long_distance", label: "Long distance" },
  { value: "local_move", label: "Local move" },
];

export const PROVIDER_VEHICLE_TYPE_OPTIONS = [
  { value: "bakkie", label: "Bakkie" },
  { value: "1_ton", label: "1 ton" },
  { value: "4_ton", label: "4 ton" },
  { value: "8_ton", label: "8 ton" },
  { value: "trailer", label: "Trailer" },
  { value: "other", label: "Other" },
];

export const BUSINESS_TYPE_OPTIONS = [
  { value: "sole_proprietor", label: "Sole proprietor" },
  { value: "pty_ltd", label: "Pty Ltd" },
  { value: "partnership", label: "Partnership" },
  { value: "cooperative", label: "Cooperative" },
  { value: "other", label: "Other" },
];

export const SETTLEMENT_PREFERENCE_OPTIONS = [
  { value: "eft", label: "EFT" },
  { value: "cash", label: "Cash" },
  { value: "both", label: "Both" },
];

/** Fallback when route corridor API is unavailable */
export const DEFAULT_ROUTE_CORRIDOR_OPTIONS = [
  { value: "WC-EC", label: "WC-EC — Western Cape to Eastern Cape" },
  { value: "WC-EC-KZN", label: "WC-EC-KZN — Western Cape to EC to KZN" },
  { value: "EC-KZN", label: "EC-KZN — Eastern Cape to KwaZulu-Natal" },
  { value: "GP-KZN", label: "GP-KZN — Gauteng to KwaZulu-Natal" },
  { value: "GP-EC", label: "GP-EC — Gauteng to Eastern Cape" },
  { value: "GP-WC", label: "GP-WC — Gauteng to Western Cape" },
  { value: "KZN-EC", label: "KZN-EC — KwaZulu-Natal to Eastern Cape" },
  { value: "KZN-GP", label: "KZN-GP — KwaZulu-Natal to Gauteng" },
  { value: "EC-WC", label: "EC-WC — Eastern Cape to Western Cape" },
];

export const MAJOR_CITY_OPTIONS = [
  "Johannesburg",
  "Pretoria",
  "Sandton",
  "Midrand",
  "Centurion",
  "Durban",
  "Pietermaritzburg",
  "Cape Town",
  "Stellenbosch",
  "Paarl",
  "George",
  "Port Elizabeth",
  "Gqeberha",
  "East London",
  "Bloemfontein",
  "Kimberley",
  "Polokwane",
  "Nelspruit",
  "Mbombela",
  "Rustenburg",
  "Welkom",
].map((city) => ({ value: city, label: city }));

export function normalizeStringList(values) {
  if (!values) return [];
  const list = Array.isArray(values)
    ? values
    : String(values)
        .split(",")
        .map((part) => part.trim())
        .filter(Boolean);
  return [...new Set(list)];
}

export function normalizeProvinceCodes(values) {
  return normalizeStringList(values)
    .map((raw) => {
      const key = String(raw).toLowerCase().trim();
      if (PROVINCE_ALIASES[key]) {
        return PROVINCE_ALIASES[key];
      }
      const upper = String(raw).toUpperCase().trim();
      if (SA_PROVINCE_OPTIONS.some((o) => o.value === upper)) {
        return upper;
      }
      return null;
    })
    .filter(Boolean);
}

export function normalizeServiceValues(values) {
  const allowed = new Set(PROVIDER_SERVICE_OPTIONS.map((o) => o.value));
  return normalizeStringList(values)
    .map((v) => String(v).toLowerCase().trim().replace(/\s+/g, "_"))
    .filter((v) => allowed.has(v));
}

export function normalizeRouteCodes(values) {
  return normalizeStringList(values).map((v) =>
    String(v).toUpperCase().trim().replace(/\s+/g, "")
  );
}

export function normalizeVehicleTypes(values) {
  const allowed = new Set(PROVIDER_VEHICLE_TYPE_OPTIONS.map((o) => o.value));
  return normalizeStringList(values)
    .map((v) => String(v).toLowerCase().trim().replace(/\s+/g, "_"))
    .filter((v) => allowed.has(v));
}

export function optionsFromValues(values, catalog) {
  const catalogMap = new Map(catalog.map((o) => [o.value, o]));
  return normalizeStringList(values).map((value) => {
    if (catalogMap.has(value)) {
      return catalogMap.get(value);
    }
    return { value, label: value };
  });
}
